import useHbaw from "./useHbaw";

const useDashboardName = () => {
  const { isHbaw } = useHbaw();

  // We will keep the custom hooks for now so it's easy if there is sudden request to 
  // differentiate the dashboard name in the HBAW environment.
  if (isHbaw) {
    return "Insights Dashboard";
  }

  return "Insights Dashboard";
};

export default useDashboardName;
